<div class="root-property-container">
  <app-image-lightbox></app-image-lightbox>
  <form [formGroup]="myForm">
    @if (selectedWorkspace) {
    <mat-form-field>
      <input matInput placeholder="Name" [readonly]="isBacklogMap" #inputName required (focus)="$event.target.select()" maxlength="255" type="text" formControlName="name" />
    </mat-form-field>
    @if (myForm.get('name')?.invalid && (myForm.get('name')?.dirty || myForm.get('name')?.touched)) {
      <mat-error>
        @if (myForm.get('name')?.hasError('required')) { Name is required. }
        @else if (myForm.get('name')?.hasError('maxlength')) { Name must be 255 characters or fewer. }
      </mat-error>
    }
    }
    <div class="description-field">
      <label class="description-field__label">Description</label>
      @if (isBacklogMap) {
      <div class="description-field__readonly">{{ myForm.value.description | htmlSanitizer : 1000 }}</div>
      } @else {
      <app-rich-text-field
        [value]="myForm.value.description"
        [projectId]="selectedWorkspace.projectId || ''"
        [workspaceId]="selectedWorkspace.id || ''"
        [attachmentDialogContext]="'workspace'"
        [attachmentDialogData]="selectedWorkspace"
        [imageNamePrefix]="selectedWorkspace.key || ''"
        (valueChange)="onDescriptionValueChange($event)"></app-rich-text-field>
      }
    </div>

    <div class="save-button-div">
      <button mat-raised-button color="primary" (click)="saveWork()" [disabled]="!myForm.valid || !myForm.dirty || locked">Save</button>
    </div>
  </form>
</div>
